import React from 'react';
import { CarouselQuiz } from 'components/molecules/Carousel/CarouselQuiz';
import emojis from 'theme/emoji';
import { FeatureContainer } from 'components/molecules/Containers/FeatureContainer';
import { ElevesDashboardProf } from 'types/classe/maClasse';
import { HeaderText } from 'components/atoms/Texts/HeaderText';
import { AvailableQuizDef } from 'types/quiz/quiz.def';
import useStyle from './featureQuiz.style';
import { EmptyDataMessage } from '../../../molecules/EmptyDataMessage';

export interface FeatureQuizViewProps {
  onClick: (quizID: string) => void;
  quizzes: AvailableQuizDef[];
  eleves: ElevesDashboardProf[];
}

export const FeatureQuizView = ({
  onClick,
  quizzes,
  eleves
}: FeatureQuizViewProps) => {
  const classes = useStyle();
  return (
    <div className={classes.root}>
      <HeaderText text="Actu quiz" emoji={emojis['LightBulb']} />
      <EmptyDataMessage
        text={'Pas de quiz à afficher 😕'}
        isVisible={!quizzes || !quizzes.length}
      />
      {quizzes && quizzes.length >= 1 && (
        <FeatureContainer>
          <CarouselQuiz onClick={onClick} quizzes={quizzes} eleves={eleves} />
        </FeatureContainer>
      )}
    </div>
  );
};
